<template>
  <div>
    <div class="news-list">
      <div class="new-li" v-for="item in news" :key="item.ID">
        <div class='imgBox' @click="openNewDetail(item)" v-if="item.NewsLogo">
          <img :src="item.NewsLogo" onerror="this.src=DomainService.PublicPath + 'resource/images/empty.jpg'">
        </div>
        <div>
          <p class="title" @click="openNewDetail(item)">{{item.NewsTitle}}</p>
          <p class="time">{{UtilService.DateFormat(item.PublishTime)}}</p>
        </div>
      </div>
    </div>
    <el-empty description="暂无数据" v-if="news.length <= 0"></el-empty>
    <div class="pagination">
      <md-page class="prod-page" :small="true" :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>
  </div>
</template>

<script>
import { CompService, ApiService } from '/@/service'
import { UtilService, DomainService } from '@/libs'

export default {
  data() {
    return {
      news: [],
      page: 1,
      total: 0,
      pageSize: 15,

      ApiService,
      UtilService,
      DomainService,
    }
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    async getNewsList() {
      const res = await CompService.getNewsList(this.$route.params.id, this.page, this.pageSize);
      if (res) {
        this.news = res.List || [];
        this.total = res.TotalCount || 0;
      }
    },
    pageChanged(param) {
      this.page = param.page;
      this.getNewsList();
    },
    openNewDetail(value) {
      this.$emit('openNewDetail', value.ID)
    }
  }
}
</script>

<style lang="less" scoped>
.news-list{
  position: relative;
  .imgBox{
    width: 150px;
    height: 90px;
    position: relative;
    margin-right: 12px;
    img{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      border: none;
      object-fit: cover;
    }
  }
  .title{
    font-size: 14px;
    font-weight: 600;
    color: @text-color-base;
    line-height: 16px;
    cursor: pointer;
  }
  .title:hover{
    color: @a-color-active;
  }
  .time{
    font-size: 12px;
    color: @text-color-help-dark;
  }
}
.new-li{
  position: relative;
  padding-bottom: 16px;
  padding-top: 8px;
  display: flex;
  align-items: center;
}
.new-li::after{
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 200px;
  height: 2px;
  border-bottom: 2px dashed #c6e4ff;
}
</style>
